import SelectorDeCarga from './SelectorDeCarga'

export default SelectorDeCarga
